<div class="postion-relative" *ngIf="uploadedFile$ | async as uploadedFiles">
    <div
        class="drag-drop-files d-flex flex-column justify-content-start"
        edpDragAndDrop
        (fileDropped)="fileDropped($event)"
        (fileIsOver)="isOver = $event"
        [ngClass]="{
            'drag-drop-files-over': isOver,
            'drag-drop-files-invalid': isInvalid || isInvalidType || isInvalidTotalSize,
            'drag-drop-files-disabled': uploadedFiles.length >= maxFileCount,
            full: isFull && uploadedFiles.length <= 4,
            'h-50': isFull && uploadedFiles.length && uploadedFiles.length <= 4,
            'sticky-upload': isFull && uploadedFiles.length > 4
        }"
    >
        <div class="drag-drop-files-over-wrapper" *ngIf="isOver; else leave">
            <i class="icon-edponline-Bop-017"></i>
            <span>{{ 'pt.edp.edponline.dragAndDrop.dropFileToUpload' | translate }}</span>
        </div>
        <ng-template #leave>
            <div class="drag-drop-files-wrapper">
                <input
                    class="drag-drop-files-input"
                    type="file"
                    #fileDropRef
                    id="{{fileDropRefId}}"
                    multiple
                    (change)="fileDropped($event.target.files)"
                />
                <label class="d-flex justify-content-start" for="{{fileDropRefId}}">
                    <i class="drag-drop-files-icon icon-edponline-Bop-074"></i>
                    <div class="drag-drop-files-description"
                        [innerHTML]="'pt.edp.edponline.requests-and-operations.create-request.detail-and-attachments.drag-files' | translate">
                    </div>
                </label>
                <div *ngIf="!isInvalid && !isInvalidType && !isInvalidTotalSize" class="drag-drop-files-note">
                    {{ filesMessageLabel | translate: { SIZE: maxFileSizeMB, TOTAL_SIZE: maxTotalSizeMB || maxFileSizeMB * maxFileCount } }}
                </div>
                <div *ngIf="isInvalid" class="drag-drop-files-invalid-message">
                    <i class="drag-drop-files-invalid-icon icon-edponline-Bop-070"></i>
                    <span>
                        {{ 'pt.edp.edponline.dragAndDrop.invalidSizeMessage' | translate: { SIZE: maxFileSizeMB } }}
                    </span>
                </div>
                <div *ngIf="isInvalidType" class="drag-drop-files-invalid-message">
                    <i class="drag-drop-files-invalid-icon icon-edponline-Bop-070"></i>
                    <span>
                        {{ 'pt.edp.edponline.dragAndDrop.invalidTypeMessage' | translate: { TYPE: allowedType } }}
                    </span>
                </div>
                <div *ngIf="isInvalidExtension" class="drag-drop-files-invalid-message">
                    <i class="drag-drop-files-invalid-icon icon-edponline-Bop-070"></i>
                    <span>
                        {{ 'pt.edp.edponline.dragAndDrop.invalidExtensionMessage' | translate }}
                    </span>
                </div>
                <div *ngIf="isInvalidTotalSize" class="drag-drop-files-invalid-message">
                    <i class="drag-drop-files-invalid-icon icon-edponline-Bop-070"></i>
                    <span>{{ 'pt.edp.edponline.dragAndDrop.isInvalidTotalSize' | translate: { TOTAL_SIZE: maxTotalSizeMB } }}</span>
                </div>
            </div>
        </ng-template>
    </div>
    <div [ngClass]="{ 'sticky-list': isFull && uploadedFiles.length > 4 }" (scroll)="onScrollFiles($event)">
        <div class="d-flex justify-content-start align-items-center flex-wrap" [ngClass]="{ row: isFull }">
            <div *ngFor="let file of files" [ngClass]="{ 'col-6': isFull }">
                <div
                    *ngIf="file.isLoading"
                    class="drag-drop-loading drag-drop-loading-completed d-flex justify-content-between align-items-center"
                    [ngClass]="{ 'drag-drop-loading-completed': file.loaded, 'drag-drop-loading-error': file.hasError, 'w-100': isFull }"
                >
                    <div class="d-flex justify-content-start align-items-center">
                        <edp-loader *ngIf="!file.loaded" class="drag-drop-loading-loader" [size]="'sm'"></edp-loader>
                        <div *ngIf="file.loaded && !file.hasError" class="icon"><i class="icon-edponline-Bop-072"></i></div>
                        <div *ngIf="file.loaded && file.hasError" class="icon"><i class="icon-edponline-Bop-071"></i></div>
                        <div class="d-flex flex-column justify-content-start">
                            <span class="drag-drop-files-name edp-color-neu-08 text-truncate" title="{{ file?.name }}">
                                {{ file.name }}
                            </span>
                            <span class="edp-color-neu-07">{{ file?.size }}</span>
                        </div>
                    </div>

                    <div *ngIf="file.loaded" class="icon-remove" (click)="removeFile(file)"><i class="icon-edponline-Bop-071"></i></div>
                </div>
            </div>
        </div>
    </div>
</div>
